import Vue from 'vue'
// import store from '@/store'

export default async () => {
  const res = await Vue.axios.post('/auth/users/resend_email_comfirmation', {})
  return res.data
}



// WEBPACK FOOTER //
// ./src/services/auth/resend-email-confirm.js